<template>
  <div style="height: 100%">
    <v-container fluid v-if="loading" style="height: 100%">
      <v-layout align-center justify-center row fill-height class="text-xs-center" style="height: 100%">
        <v-progress-circular
          :size="50"
          :color="app.color_name"
          indeterminate
          class="ma-5"
        ></v-progress-circular>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  export default {
    $_veeValidate: {
      validator: 'new'
    },
    mounted () {
      let locale = Intl.DateTimeFormat().resolvedOptions().locale || 'en'
      locale = (this.$auth.check()) ? this.$auth.user().locale : locale
      this.locale = locale

      moment.locale(this.locale.substr(0,2))

      // this.onResize()
      // window.addEventListener('resize', this.onResize, { passive: true })
    },
    data () {
      return {
        locale: 'en',
        loading: true,
        stats: null,
        statTabs: 'customers'
      }
    },
    methods: {
      formatNumber(number) {
        return new Intl.NumberFormat(this.locale.replace('_', '-')).format(number)
      }/*,
      onResize () {
        switch (this.$vuetify.breakpoint.name) {
            case 'xs': this.chartOptions.height = 320; break;
            case 'sm': this.chartOptions.height = 320; break;
            default: this.chartOptions.height = 439; break;
        }
      }*/
    },
    computed: {
      app () {
        return this.$store.getters.app
      }
    }
  }
</script>
<style>
</style>